// @flow
import { useHistory, useParams } from 'react-router-dom';
import React from 'react';
import { getLinkForStreamingProjectsSPPage } from '@streaming-projects/links';
import { useDeleteTableFlowWorkloadMutation } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { toastError, toastSuccess } from '@presentational/notifications/utils';
import { ConfirmModal } from '@presentational/modals/ConfirmModal';

export const SPTableFlowWorkloadDeleteWarningModal = ({
  isOpen,
  onClose,
  tableFlowWorkloadId,
  tableFlowWorkloadName,
  tableFlowWorkloadResourceId,
  spVersion,
}) => {
  const [deleteTableFlowWorkload] = useDeleteTableFlowWorkloadMutation();
  const { orgId, spId } = useParams();
  const { push } = useHistory();
  const header = `Delete Tableflow Workload ${tableFlowWorkloadName}`;
  const headerBody = <p>Are you sure you want to delete this Tableflow Workload?</p>;

  const onClickHandlerForOK = async () => {
    const { error } = await deleteTableFlowWorkload({
      orgId,
      spId,
      tableFlowWorkloadId,
      payload: {
        tableflow_resource_id: tableFlowWorkloadResourceId,
        sp_version: spVersion,
      },
    });
    if (error) {
      toastError(error);
    } else {
      toastSuccess('Tableflow Workload delete was successful!');
      push(getLinkForStreamingProjectsSPPage(orgId, spId));
    }
  };

  return (
    <ConfirmModal
      body={headerBody}
      header={header}
      isOpen={isOpen}
      onClickHandlerForCancel={onClose}
      onClickHandlerForOK={onClickHandlerForOK}
    />
  );
};
